import $ from 'jquery';

let $sliders;

function init() {

    $sliders = $('.extension_component_slider_deluxe');

    $sliders.each(function (index, slider) {
        let $slider = $(slider);
        let $slidesText = $slider.find('.slider-slides-text');
        let swiper = $slider.find('.swiper-container').prop('swiper');

        swiper.init();

        swiper.on('slideChange', function () {
            let swiperSlideIndex = swiper.realIndex;
            let $slide = $slider.find('.swiper-slide').eq(swiperSlideIndex);

            let $activating = $slidesText.find(dataSelector('slide', $slide.data('slide')));
            let $deactivating = $slidesText.find('.slide-text.active');

            if ($activating.is($deactivating)) {
                return;
            }

            $activating.addClass('active');
            $deactivating.removeClass('active');
        });
    });
}

function dataSelector(name, value) {
    return '[data-{name}="{value}"]'.replace('{name}', name).replace('{value}', value);
}

export default {init: init};
